import { render } from "./notify-popover.vue?vue&type=template&id=d5d302c2"
import script from "./notify-popover.vue?vue&type=script&lang=js"
export * from "./notify-popover.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__